export class EBike {
    MID: string;
    FirmwareVersion: string;
    BatterySerialNumber: string;
    BatteryManufacturingDate: string;
}